import React, { useState, useEffect, FC } from 'react'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import { compose } from 'redux'
import styles from './headerTop.module.scss'
import Select from 'react-select'
import { RootState } from '../../../redux/store'
import withRouter from '../../../hooks/withRouter'
import { Words } from '../../../types/lang'
import { languageOptions } from '../../../config/languageOptions'
import { verifyUser } from '../../../redux/user.slice'
import { setLanguage } from '../../../redux/main.slice'
import { setLanguageToLocalStorage } from '../../../utils/setLanguageToLocalStorage'
import { getLanguageFromLocalStorage } from '../../../utils/getLanguageFromLocalStorage'
import { AuthUser } from '../../../types/user'
import { Option } from '../../../types/option'

interface HeaderTopProps {
  words?: Words
  isUserVerified?: boolean
  userName?: string
  authUser: AuthUser
  history: any
  verifyUser: () => void
  setLanguage: (language: string) => void
}

const HeaderTop: FC<HeaderTopProps> = (props: HeaderTopProps) => {
  const {
    words,
    authUser,
    verifyUser,
    isUserVerified,
    userName,
    setLanguage,
    history,
  } = props
  const [selectedOption, setSelectedOption] = useState<Option>({
    value: 'esp',
    label: 'Español',
  })

  useEffect(() => {
    verifyUser()
    const language = getLanguageFromLocalStorage()

    if (language) {
      if (language === 'eng') {
        setSelectedOption({ value: 'eng', label: 'English' })
        setLanguage(language)
      } else if (language === 'esp') {
        setSelectedOption({ value: 'esp', label: 'Español' })
        setLanguage(language)
      }
    }
  }, [])

  useEffect(() => {
    if (history?.location?.pathname?.includes('/my_account')) {
      verifyUser()
    }
  }, [history?.location?.pathname])

  const onSelectLanguage = (option: Option) => {
    setLanguage(option.value)
    setLanguageToLocalStorage(option.value)
    setSelectedOption(option)
  }

  return (
    <div className={styles.container}>
      <div className={styles.leftPart}>
        <Select
          className={styles.select}
          value={selectedOption}
          //@ts-ignore
          onChange={onSelectLanguage}
          options={languageOptions}
          //@ts-ignore
          placeholder={selectedOption}
        />
      </div>
      <div className={styles.rightPart}>
        <div className={styles.rightContainer}>
          {!authUser && (
            <>
              <NavLink to="/sign_in" className={styles.itemContainer}>
                <i className={`${styles.icon} fas fa-key`}></i>
                <div>{words?.signIn}</div>
              </NavLink>

              <NavLink to="/sign_up" className={styles.itemContainer}>
                <i className={`${styles.icon} fa fa-user-plus`}></i>
                <div>{words?.signUp}</div>
              </NavLink>
            </>
          )}

          <NavLink
            to={isUserVerified ? '/my_account/my_orders' : '/sign_in'}
            className={styles.itemContainer}
          >
            <i className={`${styles.icon} fa fa-heart`}></i>
            <div>{words?.orders}</div>
          </NavLink>
          {isUserVerified ? (
            <NavLink to="/my_account" className={styles.itemContainer}>
              {authUser?.profileImage ? (
                // eslint-disable-next-line jsx-a11y/alt-text
                <img
                  src={authUser.profileImage}
                  className={styles.profileImage}
                />
              ) : (
                <i
                  className={`${styles.icon} fas fa-user-circle ${styles.userIcon}`}
                ></i>
              )}

              <div>{`${words?.hello},`}</div>
              <div className={styles.userName}>{userName}</div>
            </NavLink>
          ) : (
            <NavLink to="/sign_in" className={styles.itemContainer}>
              <i className={`${styles.icon} fa fa-user`}></i>

              <div>{words?.account}</div>
            </NavLink>
          )}
        </div>
      </div>
    </div>
  )
}

let mapStateToProps = (state: RootState) => {
  return {
    words: state.main.words,
    isUserVerified: state.user.isUserVerified,
    authUser: state.user.authUser,
    // userName: state.user.userName,
  }
}

export default compose(
  connect(mapStateToProps, {
    verifyUser,
    setLanguage,
    setLanguageToLocalStorage,
  }),
  withRouter,
)(HeaderTop)
